import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { pathKey } from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { ensureExists } from '~/utils'

export const useSurveyId = () => {
  const { t } = useTranslation()
  const { surveyId } = usePathParams(pathKey)

  return ensureExists(surveyId, t('assertion_failed'))
}
